// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_login_login_module_ts":"3e429fd7d39ea7c8","src_app_components_my-account_my-account_module_ts":"9433366b901018f1"}[chunkId] + ".js";
};